var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-table',[_c('tr',_vm._l((_vm.columns),function(col,index){return _c('td',{key:index,style:(_vm.styles(col))},[_vm._v(" "+_vm._s(_vm.item[col.field])+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }